import { inject, observer } from 'mobx-react'

import { Greeting as GreetingText } from './styles'

const Greeting = ({ store: { person } }) => <GreetingText>Hi {person.displayName}!</GreetingText>

export default inject('store')(observer(Greeting))
